<template>
	<div class="key_box">
		<div class="app_container">
			<div class="gallery_header">
				<div class="gallery_title">
                    <!-- <div class="gallery_breadcrumb nav">
						<div class="cata_item" v-on:click="jumpTo('all')">
							<div class="type_text">
								<div>首页</div>
							</div>
						</div>
					</div> -->
                    <div class="gallery_breadcrumb nav">
						<div class="cata_item" v-on:click="jumpTo('all'),changeCategory('lowCode')">
                            <!-- <i class="fa fa-angle-right" aria-hidden="true"></i> -->
							<div class="type_text">
								<div>资源中心</div>
							</div>
						</div>
					</div>
					<div class="gallery_breadcrumb nav" v-if="typeList.length>0">
                        <!-- <div class="cata_item">
                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                            <div class="type_text type_code" v-html="platformCategory ? '低代码' : '零代码'"  @click="platformCategory ? changeCategory('lowCode') : changeCategory('zeroCode')">
                            </div>

                        </div> -->
                        <div v-if="!thingjsxType" style="display: flex;">
                            <div v-for="(type,index) in typeList" v-bind:key="type.id" v-on:click="deleteShowList(index,type)" class="cata_item">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                                <div v-on:mouseenter="showCloseIcon" v-on:mouseleave="hideCloseIcon" class="type_text">
                                    <div><span v-if="index==0">全部</span>{{type}}</div>
                                    <!-- <img src="../../static/img/close.png" class="close_icon" v-if="index!=0"/> -->
                                </div>
                            </div>
                        </div>
                        <!-- 零代码面包屑 -->
                        <div v-if="thingjsxType">
                            <div class="cata_item">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                                <div class="type_text ">
                                    <div class="type_code" @click="changeCategory(thingjsxType.type)"><span>全部</span>{{thingjsxType.type}}</div><img src="../../static/img/close.png" class="close_icon">
                                </div>
                                <i class="fa fa-angle-right" aria-hidden="true" v-if="!thingjsxType.root"></i>
                                <div class="type_text" v-if="!thingjsxType.root">
                                    <div>{{thingjsxType.name}}</div><img src="../../static/img/close.png" class="close_icon">
                                </div>
                            </div>
                        </div>

					</div>
					<span v-if="(!thingjsxType)&&(!isTools)" class="modelnumber">（{{listCount}}）</span>
                    <!-- 零代码列表个数 -->
					<span v-if="thingjsxType&&(!isTools)" class="modelnumber">（{{ $store.state.zeroCodeNum }}）</span>
                    <span v-if="isTools" class="modelnumber toolsnumber">（{{toolsNum}}）</span>
				</div>
				<div class="gallery_query_params">
					<div class="search_box" v-on:keyup.enter="search" style="position: relative;">
                        <!-- <div data-v-c61190dc="" data-maidain="crePdt" v-on:click="showPanel()" class="add" binded="true" style="right: 250px;color: rgb(255, 255, 255);background: rgb(255, 97, 16);border: 1px solid;cursor: pointer;display: inline-block;font-size: 14px; position: absolute;top: 2px;padding: 3px 8px;border-radius: 3px;width: 100px;">
                            <img src="../../static/img/建模.png" alt="" class="modpng" style="width: 18px;height: 18px;font-size: 14px;text-align: center;font-weight: 400;padding: 1px;float: left;margin-right: 5px;margin-top: 2px;">申请建模<img src="../../static/img/new.png" alt="" class="newPng">
                        </div> -->
						<input class="form_control" id="keyword" autocomplete="off" />
                        <Button type="primary" size="small" v-on:click="search" style="background-color:#ff7f00;border-color:#ff7f00;margin-left: 10px;">搜索</Button>
						<div class="divider" v-show="nowShowType!='all'&&!thingjsxType&&currentType!='tools'&&currentType!='plugins'"></div>
					</div>
                    <div class="sort_box" v-show="nowShowType!='all'&&!thingjsxType&&currentType!='tools'&&currentType!='plugins'">

                        <div class="param_label">排序</div>
                        <ul class="sort_list" >
                            <li class="tooltip-box bottom" data-content="综合" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                <a v-bind:class="{active:queryData.sort=='zonghe'}" data-sort="zonghe" v-on:click="changeSort('zonghe')">
                                    <i class="fa fa-life-buoy"></i>
                                </a>
                            </li>
                            <li class="tooltip-box bottom" data-content="最多购买" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="currentType=='models'||currentType=='scenes'" v-show="orderFlag">
                                <a v-bind:class="{active:queryData.sort=='buy'}" data-sort="buy" v-on:click="changeSort('buy')">
                                    <i class="fa fa-line-chart"></i>
                                </a>
                            </li>
                            <li class="tooltip-box bottom" data-content="最多浏览" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                <a v-bind:class="{active:queryData.sort=='browse'}" data-sort="browse" v-on:click="changeSort('browse')">
                                    <i class="fa fa-eye"></i>
                                </a>
                            </li>
                            <li class="tooltip-box bottom" data-content="时间最近" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                <a v-bind:class="{active:(queryData.sort=='createTime')}" data-sort="createTime" v-on:click="changeSort('createTime')">
                                    <i class="fa fa-clock-o"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
			</div>
            <div class="appVariety">
                <!-- <span class='cata_item' style="float:left;" v-on:click="jumpTo('all')">首页</span>
                <i style="float:left;height: auto; line-height: unset; font-size: 14px;padding:0 5px" class="fa fa-angle-right" aria-hidden="true"></i> -->
                <span class='cata_item' style="float:left;" v-on:click="jumpTo('all')">资源中心</span>
                <i style="float:left;height: auto; line-height: unset; font-size: 14px;padding:0 5px" class="fa fa-angle-right" aria-hidden="true"></i>
                <div class="gallery_breadcrumb" v-if="typeList.length>0">
                    <div v-for="type in typeList" v-bind:key="type.id" class="cata_item fa">
                        <Dropdown @on-click="changeTypeList">
                            <div>{{type}}</div>
                            <DropdownMenu slot="list" >
                                <Dropdown placement="right-start">
                                    <DropdownItem name="项目">项目</DropdownItem>
                                    <DropdownMenu slot="list">
                                        <li class="ivu-dropdown-item" v-for="(item,index) in allTypeList" v-bind:key="item.id"  @click="changeAllTypeList(item,index)">{{item.catalog}}</li>
                                    </DropdownMenu>
                                </Dropdown>
                                <DropdownItem name="地图">地图</DropdownItem>
                                <DropdownItem name="场景">场景</DropdownItem>
                                <Dropdown placement="right-start">
                                    <DropdownItem name="模型">模型</DropdownItem>
                                    <DropdownMenu slot="list">
                                        <li class="ivu-dropdown-item" v-for="(item,index) in allTypeList" v-bind:key="item.id"  @click="changeAllTypeList(item,index)">{{item.catalog}}</li>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem name="教程/案例">教程/案例</DropdownItem>
                                    <DropdownMenu slot="list">
                                        <li class="ivu-dropdown-item" v-for="(item,index) in allTypeList" v-bind:key="item.id"  @click="changeAllTypeList(item,index)">{{item.catalog}}</li>
                                    </DropdownMenu>
                                </Dropdown>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <span class="expand">▼</span>
                    <span class="modelnumber">（{{listCount}}）</span>
                </div>
            </div>

            <!-- tab框 -->
			<div class="variety">
                <div class="type_category">
                    <!-- <ul>
                        <li>平台：</li>
                        <li @click="changeCategory('lowCode')" :class="{'checked-platform-category': platformCategory}">低代码</li>
                        <li @click="changeCategory('zeroCode')" :class="{'checked-platform-category': !platformCategory}">零代码</li>
                    </ul> -->
                </div>
                <!-- 低代码类别 -->
                <div class="low-code" v-if="platformCategory">
                    <div class="resource_variety" style="position: relative;display:flex;" >
                        <ul>
                            <li>资源：</li>
                            <li v-on:click="changeResource('projects','项目')">项目</li>
                            <!-- <li v-on:click="changeResource('cities','地图')">地图</li>
                            <li v-on:click="changeResource('scenes','场景')">场景</li> -->
                            <li v-on:click="changeResource('models','模型')">模型</li>
                            <li v-on:click="changeResource('plugins','插件')">插件</li>
                            <li v-on:click="changeResource('tools','下载')">下载</li>
                            <li v-on:click="changeResource('videos','教程/案例')">教程/案例</li>
                        </ul>
                        <ul style="display:flex;padding: 0;height: 29px;margin-left:10px;">
                            <!-- 3D城市一直显示，所以去掉 v-if="addProjectImgClass == 'projects'" -->
                            <li  data-maidain="crePdt" class="add" binded="true" style="color: rgb(255, 255, 255);background: #ff7f00;border: 1px solid;cursor: pointer; display: inline-block;font-size: 14px;padding: 3px 12px;border-radius: 50px;top:4px;line-height:21px;">
                                <a href="https://www.thingjs.com/guide/speedcityshow" :target="addProjectUrl!='javascript:void(0)'?'_blank':''" style="color:#fff;" ><span class="modpng newCities" style="width: 18px;height: 18px;font-size: 14px;text-align: center;font-weight: 400;padding: 1px;float: left;margin-right: 5px;margin-top: 1px;"></span>{{ addCityName }}</a>
                                <!-- <img src="/static/img/new.png" alt="" class="newPng"> -->
                            </li>
                            <li v-if="addProjectImgClass !== 'tools'&&addProjectImgClass != 'videos'&&addProjectImgClass != 'plugins'" data-v-c61190dc="" data-maidain="crePdt" class="add" binded="true" style="color: rgb(255, 255, 255);background: #ff7f00;border: 1px solid;cursor: pointer; display: inline-block;font-size: 14px;top: 4px;padding: 3px 12px;margin-left:15px;border-radius: 50px;line-height:21px;">
                                <a :href="addProjectUrl" :target="addProjectUrl!='javascript:void(0)'?'_blank':''" @click="addOtherTool(addProjectUrl)" style="color:#fff;" ><span class="modpng" :class="addProjectImgClass" style="width: 18px;height: 18px;font-size: 14px;text-align: center;font-weight: 400;padding: 1px;float: left;margin-right: 5px;margin-top: 2px;"></span>{{ addProjectName }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="type_variety" v-show="allTypeList.length!=0">
                        <ul>
                            <li>类别：</li>
                            <li v-for="(item,index) in allTypeList" v-bind:key="item.id" v-bind:class="{checked:index==0}" v-on:click="changeType(item.catalog,item.id,index)">{{item.catalog}}</li>
                        </ul>
                    </div>
                    <!-- 标注文字 -->
                    <div class = "ThingJs-txt" v-if="addProjectImgClass == 'projects'">
                        <p>
                            <!-- 所有场景均由ThingJS平台用户开发制作 -->
                            <img src = "/static/img/explain.png" alt="">
                        </p>
                    </div>
                    <div class="big_variety" v-show="bigTypeList.length!=0">
                        <ul>
                            <li>大类：</li>
                            <li v-for="(item,index) in bigTypeList" v-bind:key="item.id" v-bind:class="{checked:index==0}" v-on:click="changeBig(item.catalog,item.id,index,item.type)">{{item.catalog}}</li>
                        </ul>
                    </div>
                    <div class="small_variety" v-show="smallTypeList.length!=0">
                        <ul>
                            <li>小类：</li>
                            <li v-for="(item,index) in smallTypeList" v-bind:key="item.id" v-bind:class="{checked:index==0}" v-on:click="changeSmall(item.catalog,item.id,index)">{{item.catalog}}</li>
                        </ul>
                    </div>
                </div>
                <!-- 零代码类别 -->
                <div class="zero-code" v-if="!platformCategory">
                    <type-date @typeDateChange="typeDateClick" :isZeroCode = isZeroCode></type-date>
                </div>
                <!-- 零代码类别中，针对模型单独分类 -->
                <div v-if="!platformCategory&&!thingjsxType">
                    <div class="type_variety" v-show="allTypeList.length!=0">
                        <ul>
                            <li>类别：</li>
                            <li v-for="(item,index) in allTypeList" v-bind:key="item.id" v-bind:class="{checked:index==0}" v-on:click="changeType(item.catalog,item.id,index)">{{item.catalog}}</li>
                        </ul>
                    </div>
                    <div class="big_variety" v-show="bigTypeList.length!=0">
                        <ul>
                            <li>大类：</li>
                            <li v-for="(item,index) in bigTypeList" v-bind:key="item.id" v-bind:class="{checked:index==0}" v-on:click="changeBig(item.catalog,item.id,index)">{{item.catalog}}</li>
                        </ul>
                    </div>
                    <div class="small_variety" v-show="smallTypeList.length!=0">
                        <ul>
                            <li>小类：</li>
                            <li v-for="(item,index) in smallTypeList" v-bind:key="item.id" v-bind:class="{checked:index==0}" v-on:click="changeSmall(item.catalog,item.id,index)">{{item.catalog}}</li>
                        </ul>
                    </div>
                </div>
            </div>
		</div>
        <div id="boxHeader">
            <ModelService @hidePanel=hidePanel v-show="panelShow" :panelShow="panelShow"></ModelService>
            <CBUpload v-show="panel11" :panelShow="panelShow" @closePanel="colsePanel11" ></CBUpload>
        </div>
	</div>
</template>

<script>
    import ModelService from './ModelService.vue';
    import CBUpload from './CBUpload.vue';
    import bus from '../assets/js/eventBus.js';
    import shield from '../assets/js/shield.js';
    // thingjsx筛选栏
    import typeDate from '../views/thingjsX/typeDate/typeDate.vue';
    // thingjsx路径信息
    import {thingjsxTypeArr} from '../views/thingjsX/config-type'
	export default {
        name: "key_box",
        components: {
            ModelService,
            CBUpload,
            typeDate,
        },
		data: function() {
			return {
                panelShow: false,
                panel11:false,
                test1:false,
                ModelTips:false,
                listCount: 0,
                nowAllType:[],
                typeList: [],
                allTypeList:[],
                bigTypeList: [],
                smallTypeList: [],
                currentType:"projects",
                queryData: {
					type:"",
					bigType: "",
					smallType: "",
					keyWord: "",
					pageSize: 24,
					pageNumber: 1,
                    sort: "zonghe"
                },
                isLastPage:false,
                orderSuccess:false,
                currentstate:false,
                orderFlag:true,
                addProjectUrl: 'https://www.thingjs.com/guide/?m=sample&g=1',
                addProjectImgClass: 'projects',
                addProjectName:'创建我的项目',
                addCityName:'3D城市',
                sketchModels:false,
                queryInter:'',
                nowShowType:'all',
                // 平台类别
                platformCategory: true,
                thingjsxTypeArr: thingjsxTypeArr,
                thingjsxType:'', // 根据路径类型区分零代码
                isZeroCode: 0,
                lowCodePluginId: '', // 零代码插件类别id
                isTools:false,
                toolsNum:1,
			};
        },
        watch: {
            // 判断排序是否显示（thingjs-x数据不显示）
            currentType(newVal){
                let pathname = window.location.pathname;
                if(pathname == "/zeroCode/tools" || pathname == "/tools") {
                    this.isTools = true;
                    if(pathname == "/tools") {
                        this.toolsNum = 17;
                    }else {
                        this.toolsNum = 1;
                    }
                }else {
                    this.isTools = false;
                }
                this.thingjsxType = this.thingjsxTypeArr.find((item) =>{
                    if(item.url.includes(newVal) && newVal !== 'plugins'){
                        return item
                    }else{
                        return false
                    }
                })
            },
            // 监听零代码项目类别切换
            '$store.state.thingxProjectName'(newVal){
                let pathname = window.location.pathname;
                if(pathname == "/zeroCode/tools" || pathname == "/tools") {
                    this.isTools = true;
                    if(pathname == "/tools") {
                        this.toolsNum = 17;
                    }else {
                        this.toolsNum = 1;
                    }
                }else {
                    this.isTools = false;
                }
                if(pathname !== '/zeroCode/getProjects'||pathname !== '/zeroCode' || !newVal) return; // 如果不是项目类别或者是初始化
                this.thingjsxType = this.thingjsxTypeArr.find((item) =>{ // 否则返回对应的值
                    if(item.name && item.name.includes(newVal)){
                        return item
                    }else{
                        return false
                    }
                })
            },
            $route(to,from){
                if(from.path == '/zeroCode/tools' || (to.path != '/zeroCode/tools')) {
                    this.isTools = false;
                }else if(to.path == '/zeroCode/tools') {
                    this.isTools = true;
                    this.toolsNum = 1;
                }
            }
        },
        methods:{
            typeDateClick(date){
                let pathname = window.location.pathname;
                let path = pathname.substring(1,pathname.length)
                this.thingjsxType = this.thingjsxTypeArr.find((item) =>{
                    if(item.url && item.url.includes(path) && path !== 'plugins'){
                        return item
                    }else{
                        return false
                    }
                })
                if(date === 'models'){
                    this.changeResource(date,'模型')
                }
                this.$emit("listenToChildEvent",date);
            },
            showPanel11:function(){
                if($.cookie('openid')){
                    this.panel11 = true;
                }else{
                    logoinForStore();
                }
            },
            colsePanel11() {
                this.panel11 = false;
            },
            addOtherTool(url) {
                if(url === 'javascript:void(0)') {
                    if(this.addProjectImgClass === 'scenes') {
                        this.showPanel11();
                    }else if(this.addProjectImgClass === 'models') {
                        this.$Modal.info({
                            title: '温馨提示',
                            content:"<div class='infoMain' style='min-height:112px'><p class='infoBody'><Icon class='info-color ivu-icon ivu-icon-ios-information-circle font-size40'></Icon><span style='top:0'>您可通过 3DMax 插件上传自己的 3D 模型。3DMax 插件可在“资源中心-下载”中下载。<label class='info-bolder'></span></p></div>",
                            okText: '确定',
                            closable:true,
                            width:418.5,
                        });
                    }else {
                        return;
                    }
                }
            },
            showPanel:function(){
                if($.cookie('openid')){
                    this.panelShow = true;
                }else{
                    logoinForStore();
                }
            },
            showDevelopPanel:function(){
                if($.cookie('openid')){
                    this.panelDevelopShow = true;
                }else{
                    logoinForStore();
                }
            },
            hideDevelopPanel:function(){
                var _this = this;
                this.panelDevelopShow = false;
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
            },
            changeShowList:function(index,name){
                var flag = true;
                switch(index){
                    case 0:
                        this.typeList = [];
                        this.typeList.unshift(name);
                        break;
                    case 1:
                        this.typeList.splice(1,3,name);
                        break;
                    case 2:
                        this.typeList.splice(2,2,name);
                        break;
                    case 3:
                        this.typeList.splice(3,1,name);
                        break;
                    case 4:
                        this.typeList.splice(1,3);
                        break;
                    case 5:
                        this.typeList.splice(2,2);
                        break;
                    case 6:
                        this.typeList.splice(3,1);
                        break;
                    default:
                        flag = false;
                        console.log('changeShowList error');
                        break;
                }
                if (flag) {
                    bus.$emit('getchangeShowList_SDK',this.typeList)
                }
            },
            deleteShowList:function(index,type){
                 switch(index){
                    case 0:
                        switch(type){
                            case '项目':
                                this.changeResource('projects','项目');
                                break;
                             case '模型':
                                this.changeResource('models','模型');
                                break;
                            case '插件':
                                this.changeResource('plugins','插件');
                                break;
                             case '下载':
                                this.changeResource('tools','下载');
                                break;
                             case '教程/案例':
                                this.changeResource('videos','教程/案例');
                                break;
                            default:
                                console.log('deleteShowList error');
                                break;
                        }
                    case 1:
                        this.typeList.splice(1,3);
                        this.initChecked();
                        if(this.currentType=="projects"){
                            this.queryData.type = 'projectList';
                        }else{
                            this.queryData.type = '';
                        }
                        this.queryData.bigType = '';
                        this.queryData.smallType = '';
                        this.queryChangeList();
                        break;
                    case 2:
                        this.typeList.splice(2,2);
                        this.clearBig(1);
                        this.clearSmall(1);
                        this.queryData.bigType = '';
                        this.queryData.smallType = '';
                        this.queryChangeList();
                        break;
                    case 3:
                        this.typeList.splice(3,1);
                        this.clearSmall(1);
                        this.queryData.smallType = '';
                        this.queryChangeList();
                        break;
                    default:
                        console.log('deleteShowList error');
                        break;
                }
            },
            jumpTo:function(type){
                if(type) {
                    this.changeResource('projects','项目');
                    this.$router.push('/');
                } else {
                    window.location.href='https://www.thingjs.com';
                }
            },
            showCloseIcon: function(event) {
				$(event.target).children(".close_icon").addClass("active");
			},
			hideCloseIcon: function(event) {
				$(event.target).children(".close_icon").removeClass("active");
            },
            search: function(event) {
				var s= $("#keyword").val();
				var pattern = new RegExp("[` ~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？‘’]");
			    var rs = "";
			    for (var i = 0; i < s.length; i++) {
                    rs = rs + s.substr(i, 1).replace(pattern, '');
                }
                if(shield.shieldWords.indexOf(rs)=='-1'){

                    this.$store.commit('setThingXsearch', rs);


                    this.queryData.keyWord = rs;
                    this.queryChangeList();
                    if (rs) {
                        window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_search', {
                            queryName: rs
                        })
                    }
                }else{
                    this.showNullList();
                    // this.alert('根据相关法律法规和政策，搜索结果未予显示。');
                }
            },
            changeSort: function(newSort) {
                this.queryData.sort = newSort;
				this.queryChangeList();
			},
			showTooltip: function(event) {
				var content = $(event.target).data("content");
				var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
				$(event.target).append(tipEle);
			},
			cancelTooltip: function(event) {
				$("div").remove(".tooltips");
            },

            // 平台类别切换
            changeCategory(type){
                if(type === 'lowCode'){
                    this.platformCategory = true;
                    this.changeResource('projects','项目')
                    // this.$router.push('/projects');
                }else{
                    this.isZeroCode = ++this.isZeroCode; // 零代码类别引用监听
                    this.platformCategory = false;
                    if(type == '项目' || type == 'zeroCode') type = "zeroCode/getProjects"
                    if(type == '插件') type = "zeroCode/plugins"
                    if(type == '下载') type = "zeroCode/tools"
                    this.changeResource(type)
                    if(type == 'zeroCode'){
                        this.$store.commit('setzeroCode', true);
                    }else{
                        this.$store.commit('setzeroCode', false);
                    }
                    // this.$router.push('/application');
                }
            },


            changeResource: function(type,name){
                this.currentType = type;
                if(type=='projects'){
                    this.nowShowType ='all';
                    this.$emit("listenToChildEvent",'all');
                }else{
                    this.nowShowType ='noall';
                    this.$emit("listenToChildEvent",type);
                }
                var state = {title:'',url:window.location.href};
                history.pushState(state,'','/'+type);
                this.addProjectImgClass = type;
                switch(type){
                    case 'models':
                        this.clearResource(2);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initModelType();
                        this.orderFlag = false;
                        this.addProjectUrl = 'javascript:void(0)';
                        this.addProjectName = '上传我的模型';
                        break;
                    case 'plugins':
                        this.clearResource(3);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initPluginType();
                        this.orderFlag = false;
                        let data = {
                            keyWord: this.queryData.keyWord,
                            type: 'plugins'
                        }
                        bus.$emit('lowcodePluginSearch', data)
                        break;
                    case 'scenes':
                        this.clearResource(3);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('场景',4);
                        this.orderFlag = false;
                        this.addProjectUrl = 'javascript:void(0)'
                        this.addProjectName = '下载场景搭建工具';
                        break;
                    case 'tools':
                        this.clearResource(4);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initToolsType();
                        break;
                    case 'projects':
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('项目');
                        this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                        this.addCityName = "3D城市";
                        this.addProjectName = '创建我的项目';
                        break;
                    case 'cities':
                        this.clearResource(2);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('地图',2);
                        this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&cityBuilder=true';
                        this.addProjectName = '生成我的3D城市';
                        break;
                    case 'topos':
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('拓扑',5);
                        this.orderFlag = false;
                        break;
                    case 'charts':
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('大屏',6);
                        this.orderFlag = false;
                        break;
                    case 'dixs':
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('数据',8);
                        this.orderFlag = false;
                        break;
                    case 'senCharts':
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('图表',7);
                        this.orderFlag = false;
                        break;
                    case 'senEngines':
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('机房',9);
                        this.orderFlag = false;
                        break;
                    case 'videos':
                        this.clearResource(5);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initVideosType();
                        this.orderFlag = true;
                        break;
                    default:
                        this.clearResource(1);
                        this.initChecked();
                        this.changeShowList(0,name);
                        this.initType('项目');
                        this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                        this.addProjectName = '创建我的项目';
                        break;
                }

            },
            changeType:function(name,id,index){
                this.sketchModels = false;
                if(this.currentType == "models"){
                    if(id!='allBig' && id!='otherModels'){
                        this.bigTypeList=[];
                        this.smallTypeList=[];
                        this.clearType(index+1);
                        this.changeShowList(1,name);
                        this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[0].list[0][index].list);
                        this.clearBig(1);
                        this.clearSmall(1);
                        this.queryData.type = "charge";
                        this.queryData.bigType = id;
                        this.queryData.smallType = '';
                        this.queryChangeList();
                        this.orderFlag=true;
                    }else if(id=='otherModels'){
                        this.bigTypeList=[];
                        this.smallTypeList=[];
                        this.clearType(index+1);
                        this.changeShowList(1,name);
                        this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[0].list[0][index].list);
                        this.clearBig(1);
                        this.clearSmall(1);
                        this.queryData.type = "charge";
                        this.queryData.bigType = '';
                        this.queryData.smallType = '';
                        this.queryData.pageNumber = 1;
                        this.sketchModels = true;
                        this.orderFlag=true;
                        bus.$emit('changeOtherModelList',this.queryData);
                    }else{
                        this.bigTypeList=[];
                        this.smallTypeList=[];
                        this.initChecked();
                        this.changeShowList(4);
                        this.queryData.type = "charge";
                        this.queryData.bigType = '';
                        this.queryData.smallType = '';
                        this.sketchModels = false;
                        this.queryChangeList();
                    }
                }else if(this.currentType == "plugins"){
                    // this.nowAllType[0].list[2].list.push({"id":"mmdScene","catalog":"公开场景","list":[]});
                    // this.nowAllType[0].list[2].list.push({"id":"shopScene","catalog":"场景集市","list":[]});
                    this.bigTypeList = []

                    this.clearType(index+1);
                    this.changeShowList(1,name);

                    this.nowAllType[0].list[0].list = []
                    this.nowAllType[0].list[1].list = []
                    this.nowAllType[0].list[2].list = []
                    this.nowAllType[0].list[3].list = []

                    // let nowAllTypes = JSON.parse(JSON.stringify(this.nowAllType[0].list))
                    // console.log(nowAllTypes,"self.nowAllType[0].list[0].list")
                    // nowAllTypes.forEach((value)=>{
                    //     console.log(value.list)
                    //     value.list = []
                    // })

                    switch(id){
                        case 'interfaceTemplate':
                            this.nowAllType[0].list[0].list.push({"id":"interfaceAll","catalog":"全部","list":[]});
                            this.nowAllType[0].list[0].list.push({"id":"parkTemplate","catalog":"园区模板","list":[]});
                            this.nowAllType[0].list[0].list.push({"id":"mapTemplate","catalog":"地图模板","list":[]});
                            this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[0].list);
                            break;
                        case 'chartPlugin':
                            this.nowAllType[0].list[2].list.push({"id":"resolvingPowerAll","catalog":"全部","list":[]});
                            this.nowAllType[0].list[2].list.push({"id":"resolvingPower1920","catalog":"1920*1080","list":[]});
                            this.nowAllType[0].list[2].list.push({"id":"resolvingPowerQita","catalog":"其他分辨率","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower960","catalog":"1920*960","list":[]});

                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower720","catalog":"2160*720","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower810","catalog":"2440*810","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower810","catalog":"2520*810","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower28810","catalog":"2880*810","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower281080","catalog":"2880*1080","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower1408","catalog":"2560*1408","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower251080","catalog":"2560*1080","list":[]});
                            // this.nowAllType[0].list[2].list.push({"id":"resolvingPower3840","catalog":"分辨率2","list":[]});
                            this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[2].list);
                            break;
                        case 'accessoriesPlugin':
                            this.nowAllType[0].list[3].list.push({"id":"accessoriesAll","catalog":"全部","list":[]});
                            this.nowAllType[0].list[3].list.push({"id":"markingPoints","catalog":"点","list":[]});
                            this.nowAllType[0].list[3].list.push({"id":"connect","catalog":"线","list":[]});
                            this.nowAllType[0].list[3].list.push({"id":"noodles","catalog":"面","list":[]});
                            this.nowAllType[0].list[3].list.push({"id":"dataTemplate","catalog":"数据面板","list":[]});
                            // this.nowAllType[0].list[3].list.push({"id":"particle","catalog":"粒子","list":[]});
                            // this.nowAllType[0].list[3].list.push({"id":"entity","catalog":"实体","list":[]});
                            // this.nowAllType[0].list[3].list.push({"id":"combination","catalog":"组合","list":[]});
                            this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[3].list);
                            break;
                        case 'plugins':
                            break;
                        default :
                    }
                    this.queryData.type = id
                    this.queryData.smallType = ''
                    let data = {
                        keyWord: this.queryData.keyWord,
                        type: this.queryData.type,
                        smallType: ''
                    }
                    bus.$emit('lowcodePluginSearch', data)
                }else if(this.currentType == "scenes"){
                    if(id!="1"){
                        this.clearType(index+1);
                        this.changeShowList(1,name);
                        bus.$emit('sceneListChangeEvent',id);
                        if(id=='shopScene'){
                            this.orderFlag=true;
                        }else{
                            this.orderFlag=false;
                        }
                    }else{
                        this.clearType(index+1);
                        this.changeShowList(4);
                        bus.$emit('sceneListChangeEvent',id);
                    }
                }else if(this.currentType == "tools"){
                    this.clearType(index+1);
                    this.changeShowList(1,name);
                    bus.$emit('toolListChangeEvent',id);
                }else if(this.currentType == "projects"){
                    if(id!='projectList'){
                        this.bigTypeList=[];
                        this.clearType(index+1);
                        this.changeShowList(1,name);
                        if(id=='projectALL'){
                            this.nowShowType='projects';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/projects');
                            this.$emit("listenToChildEvent",'projects');
                        }else if(id=='projectALLZero') {
                            this.nowShowType='zeroProjects';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/projects');
                            this.$emit("listenToChildEvent",'zeroProjects');
                        }else if(id=='projectCity'){
                            this.nowShowType='cities';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/cities');
                            this.$emit("listenToChildEvent",'cities');
                            this.nowAllType[0].list[3].list = [];
                            this.nowAllType[0].list[3].list.push({"id":"mmdMap","catalog":"地图场景","list":[],"type":"Map"});
                            this.nowAllType[0].list[3].list.push({"id":"templateMap","catalog":"官方模版","list":[],"type":"Map"});
                            this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[3].list);
                        }else if(id=='projectMmd'){
                            this.nowShowType='scenes';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/scenes');
                            this.nowAllType[0].list[3].list = [];
                            this.nowAllType[0].list[3].list.push({"id":"mmdScene","catalog":"公开园区","list":[],"type":"mmdScene"});
                            this.nowAllType[0].list[3].list.push({"id":"shopScene","catalog":"园区集市","list":[],"type":"shopScene"});
                            this.nowAllType[0].list[3].list.push({"id":"templateScene","catalog":"官方模版","list":[],"type":"templateScene"});
                            this.$emit("listenToChildEvent",'scenes');
                            this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[3].list);
                        }else if(id=='topo'){
                            this.nowShowType='topos';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/topos');
                            this.$emit("listenToChildEvent",'topos');
                        }else if(id == 'chart'){
                            this.nowShowType='charts';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/charts');
                            this.$emit("listenToChildEvent",'charts');
                        }else if(id == 'dix'){
                            this.nowShowType='dixs';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/dixs');
                            this.$emit("listenToChildEvent",'dixs');
                        }else if(id == 'senChart'){
                            this.nowShowType='senCharts';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/senCharts');
                            this.$emit("listenToChildEvent",'senCharts');
                        }else if(id == 'senEngine'){
                            this.nowShowType='senEngines';
                            var state = {title:'',url:window.location.href};
                            history.pushState(state,'','/senEngines');
                            this.$emit("listenToChildEvent",'senEngines');
                        }
                    }else{
                        this.bigTypeList=[];
                        this.nowShowType='all';
                        this.queryData.pageSize = 24;
                        this.queryData.pageNumber = 1;
                        this.clearType(index+1);
                        this.changeShowList(4);
                        this.$emit("listenToChildEvent",'all');
                    }
                }else if(this.currentType == "videos"){
                    this.queryData.type = id;
                    if(id!='allVideosList'){
                        this.clearType(index+1);
                        this.changeShowList(1,name);
                        bus.$emit('videosListChangeEvent',this.queryData);
                    }else{
                        this.clearType(index+1);
                        this.changeShowList(4);
                        bus.$emit('videosListChangeEvent',this.queryData);
                    }
                }
            },
            changeBig:function(name,id,index,type){

                if(this.currentType == "projects"){
                    this.clearBig(index+1);
                    this.changeShowList(2,name);

                    if(type && type == 'Map'){
                        bus.$emit('mapListChangeEvent',id);
                    }else{
                        bus.$emit('sceneListChangeEvent',id);
                    }
                }else{
                    if(id!='allSmall'){
                        this.checkTypeOfList('big',id);
                        this.clearBig(index+1);
                        this.changeShowList(2,name);
                        this.queryData.smallType = id;
                        this.queryChangeList();
                        this.clearSmall(1);
                    }else{
                        this.smallTypeList=[];
                        this.clearBig(index+1);
                        this.clearSmall(index+1);
                        this.changeShowList(5);
                        this.queryData.smallType = '';
                        this.queryChangeList();
                    }
                }
            },
            changeSmall:function(name,id,index){
                if(id!='allSmall'){
                    this.checkTypeOfList('small',id);
                    this.clearSmall(index+1);
                    this.changeShowList(3,name);
                    this.queryData.smallType = id;
                    this.queryChangeList();
                }else{
                    this.clearSmall(index+1);
                    this.changeShowList(6);
                    this.queryData.smallType = '';
                    this.queryChangeList();
                }
            },
            initChecked:function(){
                this.clearType(1);
                this.clearBig(1);
                this.clearSmall(1);
            },
            clearResource:function(index){
                $('.resource_variety li').removeClass('checked');
                $('.resource_variety li').eq(index).addClass('checked');
            },
            clearType:function(index,name){
                $('.type_variety li').removeClass('checked');
                $('.type_variety li').eq(index).addClass('checked');
                if(name == '场景' || name == '地图'){
                    $('.type_variety li').eq(index).trigger('click');
                }
            },
            clearBig:function(index){
                $('.big_variety li').removeClass('checked');
                $('.big_variety li').eq(index).addClass('checked');
            },
            clearSmall:function(index){
                $('.small_variety li').removeClass('checked');
                $('.small_variety li').eq(index).addClass('checked');
            },
            checkTypeOfList:function(flag,id){
                if(flag == 'big'){
                    var allArr = this.nowAllType[0].list;
                    for(var i = 1;i < allArr.length; i++){
                        if(allArr[i].list[0]) {
                            for(var j = 1;j < allArr[i].list[0].length; j++){
                                if(allArr[i].list[0][j].id==id){
                                    this.clearType(i+1);
                                    this.changeShowList(1,allArr[i].catalog);
                                    this.queryData.type = allArr[i].id;
                                    this.smallTypeList=[];
                                    this.smallTypeList=this.smallTypeList.concat(allArr[i].list[0][j].list);
                                }
                            }
                        }
                    }
                }else if(flag == 'small'){
                    var allArr = this.nowAllType[0].list;
                    for(var i = 1;i < allArr.length; i++){
                        for(var j = 1;j < allArr[i].list[0].length; j++){
                            for(var k = 1;k < allArr[i].list[0][j].list.length; k++){
                                if(allArr[i].list[0][j].list[k].id==id){
                                    this.clearType(i+1);
                                    this.changeShowList(1,allArr[i].catalog);
                                    this.queryData.type = allArr[i].id;
                                    this.clearBig(j+1);
                                    this.changeShowList(2,allArr[i].list[0][j].catalog);
                                    this.queryData.bigType = allArr[i].list[0][j].id;
                                }
                            }
                        }
                    }
                }
            },
            initModelType: function() {
                this.changeShowList(0,'模型');
                $('.resource_variety li').eq('2').addClass('checked');
                var _this = this;
                this.nowAllType=[];
                this.allTypeList=[];
                this.bigTypeList=[];
                this.smallTypeList=[];
                this.nowAllType.push({"id":"models","catalog":"模型","list":[]});
                // this.nowAllType[0].list.push({"id":"allModels","catalog":"全部","list":[]});
                this.nowAllType[0].list.push({"id":"charge","catalog":"收费模型","list":[]});
                // this.nowAllType[0].list.push({"id":"free","catalog":"免费模型","list":[]});
                var p1 = new Promise((resolve, reject) => {
                    this.$reqs.get("/model/queryAllType_charge", {}).then(res=>{
                        if(res.data && res.data.state) {
                            var content = res.data.content;
                            var contentLen = content.length;
                            if(contentLen>0){
                                content.unshift({"id":"allBig","catalog":"全部","list":[]});
                                if($.cookie('role')=='developer') content.push({"id":"otherModels","catalog":"sketchfab模型","list":[]});
                                for(var i = 1;i < contentLen+1 ; i++){
                                    content[i].list.unshift({"id":"allSmall","catalog":"全部","list":[]});
                                }
                            }
                            _this.nowAllType[0].list[0].list.push(content);
                        } else {
                            console.log("init chargeModels error");
                        }
                        resolve();
                    }).catch(err=>{
                        reject(err);
                    })
                });
                var p2 = new Promise((resolve, reject) => {
                    this.$reqs.get("/model/queryAllType", {}).then(res=>{
                        if(res.data && res.data.state) {
                            var content = res.data.content;
                            var contentLen = content.length;
                            if(contentLen>0){
                                content.unshift({"id":"allBig","catalog":"全部","list":[]});
                                for(var i = 1;i < contentLen+1; i++){
                                    content[i].list.unshift({"id":"allSmall","catalog":"全部","list":[]});
                                }
                            }
                            // _this.nowAllType[0].list[2].list.push(content);
                        } else {
                            console.log("init freeModels error");
                        }
                        resolve();
                    }).catch(err=>{
                        reject(err);
                    })
                });
                Promise.all([p1,p2]).then(res=>{
                    this.allTypeList = this.allTypeList.concat(this.nowAllType[0].list[0].list[0]);
                    // this.allTypeList = this.allTypeList.concat(this.nowAllType[0].list);
                    // this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[0].list[0]);
                    // this.smallTypeList = this.smallTypeList.concat(this.bigTypeList[1].list);
                    // console.log(this.nowAllType);
                });
            },
            initPluginType: function() {
                this.changeShowList(3,'插件');
                $('.resource_variety li').eq('3').addClass('checked');
                var _this =this;
                this.nowAllType=[];
                this.bigTypeList=[];
                this.smallTypeList=[];
                this.nowAllType.push({"id":"plugins","catalog":"插件","list":[]});
                // this.allTypeList = this.nowAllType[0].list;
                this.nowAllType[0].list.push({"id":"interfaceTemplate","catalog":"效果模板","list":[]});
                this.nowAllType[0].list.push({"id":"chartPlugin","catalog":"图表","list":[]});
                this.nowAllType[0].list.push({"id":"accessoriesPlugin","catalog":"标记","list":[]});
                //零代码
                this.nowAllType[0].list.push({"id":"layerPlugin","catalog":"图层业务","list":[]});
                this.nowAllType[0].list.push({"id":"businessPlugin","catalog":"业务模板","list":[]});
                this.nowAllType[0].list.push({"id":"twinsPanel","catalog":"孪生体面板","list":[]});
                this.nowAllType[0].list.push({"id":"sceneControlPlugin","catalog":"场景控制插件","list":[]});
                this.nowAllType[0].list.push({"id":"skinPlugin","catalog":"皮肤插件","list":[]});
                this.nowAllType[0].list.push({"id":"corePlugin","catalog":"核心插件","list":[]});
                this.nowAllType[0].list.push({"id":"extendPlugin","catalog":"扩展插件","list":[]});
                this.nowAllType[0].list.push({"id":"operatingAtom","catalog":"操作原子","list":[]});

                this.allTypeList = this.nowAllType[0].list;
                this.allTypeList.unshift({id:"plugins",catalog: "全部"});

            },
            initType:function(name,index){
                this.changeShowList(0,'项目');
                if(name != '项目'){
                    this.changeShowList(1,name);
                }
                $('.resource_variety li').eq('1').addClass('checked');
                var _this =this;
                this.nowAllType=[];
                this.bigTypeList=[];
                this.smallTypeList=[];
                this.nowAllType.push({"id":"projects","catalog":"项目","list":[]});
                this.allTypeList = this.nowAllType[0].list;
                this.nowAllType[0].list.push({"id":"projectALL","catalog":"低代码项目","list":[]});
                this.nowAllType[0].list.push({"id":"projectALLZero","catalog":"零代码项目","list":[]});
                this.nowAllType[0].list.push({"id":"projectCity","catalog":"地图","list":[]});
                this.nowAllType[0].list.push({"id":"projectMmd","catalog":"园区","list":[]});
                this.nowAllType[0].list.push({"id":"topo","catalog":"拓扑","list":[]});
                this.nowAllType[0].list.push({"id":"chart","catalog":"大屏","list":[]});
                this.nowAllType[0].list.push({"id":"senChart","catalog":"图表","list":[]});
                this.nowAllType[0].list.push({"id":"dix","catalog":"数据","list":[]});
                this.nowAllType[0].list.push({"id":"senEngine","catalog":"机房","list":[]});
                if(name == '场景' || name == '项目'){
                    this.nowAllType[0].list[2].list.push({"id":"mmdScene","catalog":"公开园区","list":[]});
                    this.nowAllType[0].list[2].list.push({"id":"shopScene","catalog":"园区集市","list":[]});
                    this.nowAllType[0].list[2].list.push({"id":"templateScene","catalog":"官方模版","list":[]});
                }else if(name == '地图'){
                    this.nowAllType[0].list[2].list.push({"id":"mmdMap","catalog":"地图场景","list":[]});
                    this.nowAllType[0].list[2].list.push({"id":"templateMap","catalog":"官方模版","list":[]});
                }
                this.allTypeList = this.nowAllType[0].list;
                this.allTypeList.unshift({id:"projectList",catalog: "全部"});
                if(name != '地图' && name != '项目'){
                    this.bigTypeList = this.bigTypeList.concat(this.nowAllType[0].list[index].list);
                }
                if(name != '项目'){
                    _this.$nextTick(()=>{
                        setTimeout(function(){
                        _this.clearType(parseInt(index+1),name);
                    },1);
                    })
                }
            },
            initVideosType:function(){
                this.changeShowList(0,'教程/案例');
                $('.resource_variety li').eq('5').addClass('checked');
                var _this = this;
                this.nowAllType=[];
                this.bigTypeList=[];
                this.smallTypeList=[];
                this.nowAllType.push({"id":"videos","catalog":"教程/案例","list":[]});
                this.nowAllType[0].list.push({"id":"tjs2019","catalog":"ThingJS教程(2019版)","list":[]});
                this.nowAllType[0].list.push({"id":"tjs2020","catalog":"ThingJS教程(2020版)","list":[]});
                this.nowAllType[0].list.push({"id":"campus","catalog":"CampusBuilder教程","list":[]});
                this.nowAllType[0].list.push({"id":"chart","catalog":"QuickChart教程","list":[]});
                this.nowAllType[0].list.push({"id":"industryVideos","catalog":"ThingJS行业案例","list":[]});
                // this.nowAllType[0].list.push({"id":"illustrateVideos","catalog":"说明","list":[]});
                this.allTypeList = this.nowAllType[0].list;
                this.allTypeList.unshift({id:"allVideosList",catalog: "全部"});
            },
            initToolsType:function(){
                this.changeShowList(0,'下载');
                $('.resource_variety li').eq('4').addClass('checked');
                var _this = this;
                this.nowAllType=[];
                this.bigTypeList=[];
                this.smallTypeList=[];
                this.nowAllType.push({"id":"tools","catalog":"下载","list":[]});
                this.allTypeList = this.nowAllType[0].list;
            },
            queryChangeList:function(){
                if(this.currentType=="models"){
                    this.queryData.type = "charge";
                    this.queryData.pageNumber = 1;
                    if(this.sketchModels) {
                        bus.$emit('changeOtherModelList',this.queryData);
                    } else {
                        bus.$emit('changeModelList',this.queryData);
                    }
                }else if(this.currentType=="scenes"){
                    if(this.orderFlag){
                        bus.$emit('changeSceneList',this.queryData);
                    }else{
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeAllSceneList',this.queryData);
                    }
                }else if(this.currentType=="tools"){
                    bus.$emit('changeToolList',this.queryData);
                }else if(this.currentType=="plugins"){
                    let data = {
                        keyWord: this.queryData.keyWord,
                        type: this.queryData.type,
                        smallType: this.queryData.smallType
                    }
                    bus.$emit('lowcodePluginSearch', data)
                }else if(this.currentType=="projects"){
                    if(this.nowShowType=='cities'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeCityList',this.queryData);
                    }else if(this.nowShowType=='scenes'){
                        // if(this.orderFlag){
                        //     console.log('00');
                        //     bus.$emit('changeSceneList',this.queryData);
                        // }else{
                            this.queryData.pageNumber = 1;
                            bus.$emit('changeAllSceneList',this.queryData);
                        // }
                    }else if(this.nowShowType=='projects'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeProjectList',this.queryData);
                    }else if(this.nowShowType=='all'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeAllList',this.queryData);
                    }else if(this.nowShowType=='topos'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeTopoList',this.queryData);
                    }else if(this.nowShowType=='charts'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeChartList',this.queryData);
                    }else if(this.nowShowType=='dixs'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeDixList',this.queryData);
                    }else if(this.nowShowType=='senCharts'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('addSenChartList',this.queryData);
                    }else if(this.nowShowType=='senEngines'){
                        this.queryData.pageNumber = 1;
                        bus.$emit('addSenChartList',this.queryData);
                    }
                    else{
                        this.queryData.pageNumber = 1;
                        bus.$emit('changeProjectList',this.queryData);
                    }
                }else if(this.currentType=='cities'){
                    this.queryData.pageNumber = 1;
                    bus.$emit('changeCityList',this.queryData);
                }else if(this.currentType=='projectsforvip'){
                    // this.queryData.pageNumber = 1;
                    // bus.$emit('changeProjectForVipList',this.queryData);
                }else if(this.currentType=='videos'){
                    this.queryData.pageNumber = 1;
                    bus.$emit('changeVideosList',this.queryData);
                }
            },
            showNullList:function(){
                if(this.currentType=="models"){
                    bus.$emit('showModelNull','');
                }else if(this.currentType=="scenes"){
                    bus.$emit('showSceneNull','');
                }else if(this.currentType=="projects"){
                    bus.$emit('showProjectNull','');
                }else if(this.currentType=='cities'){
                    bus.$emit('showCityNull','');
                }else if(this.currentType=='topos'){
                    bus.$emit('showTopoNull','');
                }else if(this.currentType=='charts'){
                    bus.$emit('showChartNull','');
                }else if(this.currentType=='dixs'){
                    bus.$emit('showDixNull','');
                }else if(this.currentType=='senCharts'){
                    bus.$emit('showSenChartNull','');
                }else if(this.currentType=='senEngines'){
                    bus.$emit('showSenChartNull','');
                }
            },
            addMore:function(){
                if(this.currentType=='models'){
                    if(this.sketchModels){
                        bus.$emit('addOtherModelList',this.queryData);
                    }else{
                        bus.$emit('addModelList',this.queryData);
                    }
                }else if(this.currentType=='projects'){
                    bus.$emit('addProjectlList');
                }else if(this.currentType=='cities'){
                    bus.$emit('addCitylList');
                }else if(this.currentType=='scenes'){
                    bus.$emit('addSceneList',this.queryData);
                }else if(this.currentType=='topos'){
                    bus.$emit('addTopoList');
                }else if(this.currentType=='charts'){
                    bus.$emit('addChartList');
                }else if(this.currentType=='dixs'){
                    bus.$emit('addDixList');
                }else if(this.currentType=='senCharts'){
                    bus.$emit('addSenChartList');
                }else if(this.currentType=='senEngines'){
                    bus.$emit('addSenChartList');
                }
            },
            UrlSearch:function(){
                var name,value;
                var obj={};
                var str= window.location.href;
                var num= str.indexOf("?")
                str = str.substr(num+1);
                var arr = str.split("&");
                for(var i=0;i < arr.length;i++){
                    num=arr[i].indexOf("=");
                    if(num>0){
                        name=arr[i].substring(0,num);
                        value=arr[i].substr(num+1);
                        obj[name]=value;
                    }
                }
                return obj;
            },
            initpathname(){
                var pathname = window.location.pathname;
                this.nowShowType ='noall';
                if(pathname!="/"){
                    switch(pathname){
                        case "/models":
                            this.initModelType();
                            this.orderFlag = false;
                            this.addProjectUrl = 'javascript:void(0)';
                            this.addProjectName = '上传我的模型';
                            this.currentType = 'models';
                            this.addProjectImgClass = 'models';
                            break;
                        case "/scenes":
                            this.initType('场景',4);
                            this.orderFlag = false;
                            this.addProjectUrl = 'javascript:void(0)';
                            this.addProjectName = '下载场景搭建工具';
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/topos":
                            this.initType('拓扑',5);
                            this.orderFlag = false;
                            // this.addProjectUrl = 'javascript:void(0)';
                            // this.addProjectName = '';
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/charts":
                            this.initType('大屏',6);
                            this.orderFlag = false;
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/dixs":
                            this.initType('数据',8);
                            this.orderFlag = false;
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/senCharts":
                            this.initType('图表',7);
                            this.orderFlag = false;
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/senEngines":
                            this.initType('机房',9);
                            this.orderFlag = false;
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/plugins":
                            this.initPluginType();
                            // this.orderFlag = false;
                            // this.addProjectUrl = 'javascript:void(0)';
                            // this.addProjectName = '';
                            let data = {
                                keyWord: this.queryData.keyWord,
                                type: 'plugins'
                            }
                            bus.$emit('lowcodePluginSearch', data)
                            this.currentType = 'plugins';
                            this.addProjectImgClass = 'plugins';
                            break;
                        case "/tools":
                            this.initToolsType();
                            this.currentType = 'tools';
                            this.addProjectImgClass = 'tools';
                            break;
                        case "/projects":
                            this.queryData.type='projectList';
                            this.initType('项目');
                            this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                            this.addProjectName = '创建我的项目';
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            this.nowShowType ='all';
                            break;
                        case "/":
                            this.queryData.type='projectList';
                            this.initType('项目');
                            this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                            this.addProjectName = '创建我的项目';
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/cities":
                            this.initType('地图',3);
                            this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&cityBuilder=true';
                            this.addProjectName = '生成我的3D城市';
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                            break;
                        case "/videos":
                            this.initVideosType();
                            this.orderFlag = true;
                            this.currentType = 'videos';
                            this.addProjectImgClass = 'videos';
                            break;
                        case "/zeroCode":
                            this.changeCategory('zeroCode/getProjects');
                            break;
                        case "/zeroCode/getProjects":
                            this.changeCategory('zeroCode/getProjects');
                            break;
                        case "/zeroCode/plugins":
                            this.changeCategory('zeroCode/plugins');
                            break;
                        case "/zeroCode/tools":
                            this.changeCategory('zeroCode/tools');
                            break;
                        case "/zeroCode/interfaceTemplate":
                            this.changeCategory('zeroCode/interfaceTemplate');
                            break;
                        case "/zeroCode/layerPlugin":
                            this.changeCategory('zeroCode/layerPlugin');
                        break;
                        case "/zeroCode/extendPlugin":
                            this.changeCategory('zeroCode/extendPlugin');
                        break;
                        case "/zeroCode/corePlugin":
                            this.changeCategory('zeroCode/corePlugin');
                        break;
                        case "/zeroCode/twinsPanel":
                            this.changeCategory('zeroCode/twinsPanel');
                        break;
                        case "/zeroCode/operatingAtom":
                            this.changeCategory('zeroCode/operatingAtom');
                        break;
                        case "/zeroCode/businessPlugin":
                            this.changeCategory('zeroCode/businessPlugin');
                        break;
                        case "/zeroCode/sceneControlPlugin":
                            this.changeCategory('zeroCode/sceneControlPlugin');
                        break;
                        case "/zeroCode/accessoriesPlugin":
                            this.changeCategory('zeroCode/accessoriesPlugin');
                        break;
                        case "/zeroCode/chartPlugin":
                            this.changeCategory('zeroCode/chartPlugin');
                        break;
                        case "/zeroCode/skinPlugin":
                            this.changeCategory('zeroCode/skinPlugin');
                        break;
                        case "/zeroCode/otherPlugin":
                            this.changeCategory('zeroCode/otherPlugin');
                        break;
                        default:
                            this.queryData.type='projectList';
                            this.initType('项目');
                            this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                            this.addProjectName = '创建我的项目';
                            this.currentType = 'projects';
                            this.addProjectImgClass = 'projects';
                        break;
                    }
                }else{
                    this.initViewType();
                }
            },
            initViewType(){
                var url = window.location.href;
                var obj = this.UrlSearch(url);
                this.currentType = obj.t?obj.t:'projects';
                this.addProjectImgClass = obj.t;
                switch(obj.t){
                    case "models":
                        this.initModelType();
                        this.orderFlag = false;
                        this.addProjectUrl = 'javascript:void(0)';
                        this.addProjectName = '上传我的场景';
                        break;
                    case "plugins":
                        this.initPluginType();
                        this.orderFlag = false;
                        // this.addProjectUrl = 'javascript:void(0)';
                        // this.addProjectName = '上传我的场景';
                        break;
                    case "scenes":
                        this.initType('场景',4);
                        this.orderFlag = false;
                        this.addProjectUrl = 'javascript:void(0)'
                        this.addProjectName = '下载场景搭建工具';
                        break;
                    case "tools":
                        this.initToolsType();
                        break;
                    case "projects":
                        this.queryData.type='projectList';
                        this.initType('项目');
                        this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                        this.addProjectName = '创建我的项目';
                        break;
                    case "cities":
                        this.initType('地图',2);
                        this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&cityBuilder=true';
                        this.addProjectName = '生成我的3D城市';
                        break;
                    case "topos":
                        this.initType('拓扑',5);
                        this.orderFlag = false;
                        break;
                    case "charts":
                        this.initType('大屏',6);
                        this.orderFlag = false;
                        break;
                    case "dixs":
                        this.initType('数据',8);
                        this.orderFlag = false;
                        break;
                    case "senCharts":
                        this.initType('图表',7);
                        this.orderFlag = false;
                        break;
                    case "senEngines":
                        this.initType('机房',9);
                        this.orderFlag = false;
                        break;
                    case "videos":
                        this.initVideosType();
                        this.orderFlag = true;
                        break;
                    default:
                        this.queryData.type='projectList';
                        this.initType('项目');
                        this.addProjectUrl = 'https://www.thingjs.com/guide/?m=sample&g=1';
                        this.addProjectName = '创建我的项目';
                        this.addProjectImgClass = 'projects';
                    break;
                }
            },
            initEject(){
                var url = window.location.href;
                var obj = this.UrlSearch(url);
                if(obj && obj.e == "modeling"){
                    if($.cookie('openid')){
                        this.panelShow = true;
                    }
                }
            },
            changeTypeList(name){
                var _this = this;
                if(name == "项目"){
                    _this.changeResource('projects','项目')
                }else if(name == "地图"){
                    _this.changeResource('cities','地图');
                }else if(name == "场景"){
                    _this.changeResource('scenes','场景');
                }else if(name == "模型"){
                    _this.changeResource('models','模型');
                }else if(name == "下载"){
                    _this.changeResource('tools','下载');
                }else if(name == "教程/案例"){
                    _this.changeResource('videos','教程/案例');
                }
            },
            changeAllTypeList(item,index){
                var _this = this;
                _this.changeType(item.catalog,item.id,index)
            },
            changeBigTypeList(item,index){
                var _this = this;
                _this.changeBig(item.catalog,item.id,index);
            },
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            buySceneFromMMD:function(){
                var _this=this;
                var paras = this.$route.query;
                if(paras.type == "sceneshop"){
                    if($.cookie('openid')){
                        var content = {type:"shopScene",id:paras.id};
                        // this.currentType = "scenes";
                        this.typeList = ['项目','场景'];
                        this.changeType("场景集市","shopScene",1);
                        if($.cookie('mmdId') == paras.userid){
                            content.action = "buy";
                        }
                        _this.$nextTick(()=>{
                            _this.changeType('场景','projectMmd',3);
                            bus.$emit('sceneShopfromMMD',content);
                            _this.$nextTick(()=>{
                               _this.clearBig(2);
                               setTimeout(()=>{
                                _this.changeBig('场景集市','shopScene',1)
                               },100);
                            });
                            // setTimeout(function(){
                                // _this.changeType('场景','projectMmd',3);
                                // bus.$emit('sceneShopfromMMD',content);
                            // },100)
                        })
                    }else{
                        this.queryInter = setInterval(() => {
                            if(typeof logoinForStore != 'undefined' && logoinForStore instanceof Function){
                                logoinForStore('fromMMD');
                                clearInterval(this.queryInter);
                            }
                        }, 100);
                    }
                }
                bus.$on('sceneCheck', () => {
                    this.clearType(2);
                })
            }
        },
		mounted: function() {
            var queryFlag = true;
            var _this = this;
            this.initpathname();
            this.initEject();
            bus.$on("changeListCount", (count) => {
                if(Number(count)>0){
                    this.listCount = count;
                    this.isLastPage = false;
                }else{
                    if(count=='-1'){
                        this.listCount = 0;
                        this.isLastPage = true;
                    }else{
                        this.listCount = $('.modelList_item').length;
                        this.isLastPage = true;
                    }
                }
            });
            bus.$on("lockScroll", (flag) => {
                this.isLastPage = flag;
            });
            $(window).on("scroll.loadMore", function() {
				var scrollTop = $(this).scrollTop();
				var scrollHeight = $(document).height();
                var windowHeight = $(this).height();
				if(scrollTop + windowHeight + 1 >= scrollHeight && !_this.isLastPage) {
					setTimeout(function() {
                        if(queryFlag){
                            // console.log('_this.$parent.$refs.Key: ', _this.$parent.$refs.Key.isLastPage);
                            // if(!_this.$parent.$refs.Key.isLastPage){
                            //     _this.queryData.pageNumber++;
                            //     // _this.addMore();
                            // }
                            if($("#keyword").val().length>0){
                                queryFlag = false;
                                setTimeout(function(){
                                    queryFlag = true;
                                },2000);
                            }
                        }
					}, 300);
                }
                if(scrollTop==0){
                    $('.navHeader').css("display","block");
                     $('#scrollToTop').removeClass('fadeToTop').addClass('fadeToBottom');
                    $('#scrollToTop').hide();
                }
                if(scrollTop>50){
                    $('.navHeader').css("display","none");
                    $('#scrollToTop').removeClass('fadeToBottom').addClass('fadeToTop');
                    $('#scrollToTop').show();
                    $('#scrollToTop').css("margin-bottom","40px");
                }
            });
            if (_this.isMobile()) {
                _this.queryData.isAPP = true;
            } else {
                _this.queryData.isAPP = false;
            }
            this.buySceneFromMMD();
		}
	};
</script>

<style>
    @import '../assets/css/key.css';
</style>



// WEBPACK FOOTER //
// src/components/Key.vue